import type { MaterialInfo, PartDefinition } from "@rogue/rackbuilder"
import { getRackModel } from "../modelPaths"
import { RackOptions, WallMountOptions } from "../RackTypes"

export function addPlateStorage(
  config: RackOptions | WallMountOptions,
  left: boolean,
  materials: MaterialInfo,
  sideTransform: Partial<PartDefinition>,
  plateStorageConfig?: string | undefined,
  leftFirstRowPlates?: PartDefinition[],
  rightFirstRowPlates?: PartDefinition[],
  leftSecondRowPlates?: PartDefinition[],
  rightSecondRowPlates?: PartDefinition[]
) {

  // All storage variations start with two long posts on the bottom
  const storagePins = [
    {
      mesh  : getRackModel(`${config.line}_STORAGE`, 'plate_storage'),
      slots : !config.bar && config.plates && plateStorageConfig
        ? {
          plate_storage: left ? leftFirstRowPlates : rightFirstRowPlates,
        }
        : {},
      materials,
      ...sideTransform,
    },
    {
      mesh  : getRackModel(`${config.line}_STORAGE`, 'plate_storage'),
      slots : !config.bar && config.plates && plateStorageConfig
        ? {
          plate_storage: left ? leftSecondRowPlates : rightSecondRowPlates,
        }
        : {},
      materials,
      ...sideTransform,
      offset: { y: 18 },
    },
  ] as PartDefinition[]

  // Push different posts into storagePins to create the different options
  if (plateStorageConfig === '8 long') {
    storagePins.push(
      {
        mesh   : getRackModel(`${config.line}_STORAGE`, 'plate_storage'),
        slots  : {},
        materials,
        ...sideTransform,
        offset : { y: 36 },
      },
      {
        mesh   : getRackModel(`${config.line}_STORAGE`, 'plate_storage'),
        slots  : {},
        materials,
        ...sideTransform,
        offset : { y: 54 },
      }
    )
  } else if (plateStorageConfig === '4 long 4 short') {
    storagePins.push({
      mesh   : getRackModel(`${config.line}_STORAGE`, 'short_plate_storage'),
      slots  : {},
      materials,
      ...sideTransform,
      offset : { y: 36 },
    },
    {
      mesh   : getRackModel(`${config.line}_STORAGE`, 'short_plate_storage'),
      slots  : {},
      materials,
      ...sideTransform,
      offset : { y: 48 },
    })
  } else if (plateStorageConfig === '6 long 4 short') {
    storagePins.push({
      mesh   : getRackModel(`${config.line}_STORAGE`, 'plate_storage'),
      slots  : {},
      materials,
      ...sideTransform,
      offset : { y: 36 },
    },
    {
      mesh   : getRackModel(`${config.line}_STORAGE`, 'short_plate_storage'),
      slots  : {},
      materials,
      ...sideTransform,
      offset : { y: 48 },
    },
    {
      mesh   : getRackModel(`${config.line}_STORAGE`, 'short_plate_storage'),
      slots  : {},
      materials,
      ...sideTransform,
      offset : { y: 60 },
    })
  } else if (plateStorageConfig === '6 long 2 short') {
    storagePins.push({
      mesh   : getRackModel(`${config.line}_STORAGE`, 'plate_storage'),
      slots  : {},
      materials,
      ...sideTransform,
      offset : { y: 36 },
    },
    {
      mesh   : getRackModel(`${config.line}_STORAGE`, 'short_plate_storage'),
      slots  : {},
      materials,
      ...sideTransform,
      offset : { y: 48 },
    })
  }

  return storagePins
}

export function addSpacersToPlateStorage(
  config: RackOptions | WallMountOptions,
  materials: MaterialInfo,
  sideTransform: Partial<PartDefinition>,
  storagePins: PartDefinition[]
) {

  storagePins.push(
    {
      mesh  : getRackModel(`${config.line}_STORAGE`, 'plate storage spacers'),
      slots : {},
      materials,
      ...sideTransform,
    }
  )
  storagePins.push(
    {
      mesh   : getRackModel(`${config.line}_STORAGE`, 'plate storage spacers'),
      slots  : {},
      offset : { y: 18 },
      materials,
      ...sideTransform,
    },
    {
      mesh   : getRackModel(`${config.line}_STORAGE`, 'plate storage spacers'),
      slots  : {},
      offset : { y: 36 },
      materials,
      ...sideTransform,
    },
    {
      mesh   : getRackModel(`${config.line}_STORAGE`, 'plate storage spacers'),
      slots  : {},
      offset : { y: 54 },
      materials,
      ...sideTransform,
    }
  )

  return storagePins
}
